import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import ActionCalendarContainer from './ActionCalendarContainer';
import TimeInput from './TimeInput'; // 🕒アイコン入力
import { TIME_OUTPUT_FORMAT } from '../../constants/calender';
import { format } from 'date-fns';

interface TimePickerProps {
  placeholder?: string;
  className?: string;
  selectedTime: Date | null;
  setSelectedTime: (time: Date | null) => void;
  ref?: React.Ref<HTMLButtonElement>;
  onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
}

const TimePicker = ({
  placeholder = 'HH:mm',
  className,
  selectedTime,
  setSelectedTime,
  ref,
  onKeyDown,
}: TimePickerProps) => {
  const [open, setOpen] = useState(false);
  const [pickedTime, setPickedTime] = useState<Date | null>(selectedTime);

  const handleOk = () => {
    setSelectedTime(pickedTime);
    setOpen(false);
  };

  return (
    <div className="d-flex">
      <DatePicker
        selected={open ? pickedTime : selectedTime}
        onChange={(d: Date | null) => setPickedTime(d)}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={30}
        timeFormat={TIME_OUTPUT_FORMAT}
        dateFormat={TIME_OUTPUT_FORMAT}
        // 開閉制御：🕒で開き、OK/キャンセルで閉じる
        open={open}
        shouldCloseOnSelect={false}
        onClickOutside={() => setOpen(false)}
        onInputClick={() => setOpen(true)}
        popperPlacement="bottom"
        portalId="root"
        customInput={
          <TimeInput
            onClick={() => setOpen(true)}
            placeholder={placeholder}
            value={selectedTime ? format(selectedTime, 'HH:mm') : ''}
          />
        }
        // 幅対策：CSSが当たるように rdp-time / rdp-with-footer を付与
        calendarContainer={(p) => (
          <ActionCalendarContainer
            {...p}
            className={`${p.className ?? ''} rdp-time rdp-with-footer`}
            onOk={handleOk}
            onCancel={() => setOpen(false)}
          >
            {p.children}
          </ActionCalendarContainer>
        )}
        className={`form-control text-center ${className ?? ''}`}
        placeholderText={placeholder}
      />
      <button
        type="button"
        className="input-group-text"
        onClick={() => setOpen(true)}
        ref={ref}
        onKeyDown={onKeyDown}
      >
        🕒
      </button>
    </div>
  );
};

export default TimePicker;
